
/* injects from baggage-loader */

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ClosePopup, OpenPopup } from '../../../actions/ui';
import Config from '../../../config/main';
import { t } from '../../../helpers/translator';
import { store } from '../../../index/terminalApp';

import KeyboardInput from '../InputKeyboard';

let waitingDefer = null;

const StaffLoginPopup = ({ dispatch }) => {
    const [errorMsg, setErrorMsg] = useState('');
    const [password, setPassword] = useState('');

    useEffect(() => {
        return () => {
            waitingDefer.resolve(false);
            waitingDefer = null;
        }
    }, []);

    const onPasswordChange = (value) => {
        setPassword(value);

        if (value.length !== Config.main.staffPassword.length) return;

        if (value === Config.main.staffPassword) {
            waitingDefer && waitingDefer.resolve(true);
            dispatch(ClosePopup());
        } else setErrorMsg('Wrong password');
    }

    const submit = e => {
        e.preventDefault();
        if (password === Config.main.staffPassword) {
            waitingDefer && waitingDefer.resolve(true);
            dispatch(ClosePopup());
        } else setErrorMsg('Wrong password');
    }

    return <form onSubmit={submit}>
        <div className="popup-contain-table-m login-form-m">
            <div className="center-view-contain-form">
                <div className="mini-logo-view">
                    <div className="mini-logo-container" />
                </div>
                <div className="form-contain-box">
                    <KeyboardInput
                        type="password"
                        placeholder={t('Password')}
                        value={password}
                        onChange={onPasswordChange}
                        className="single-form-item"
                        setFocus
                        numeric
                    />

                    {errorMsg && <div className="login-error"><span>{t(errorMsg)}</span></div>}

                    <div className="separator-box-buttons-m">
                        <button
                            className="button-view-normal-m"
                            disabled={!password}
                            type="submit"
                        >{t("Login")}</button>
                    </div>
                </div>
            </div>
        </div>
    </form>;
};

export const checkForStaffPass = () => new Promise((resolve, reject) => {
    if (!Config.main.staffPassword) resolve(true);
    else {
        waitingDefer = { resolve, reject };
        store.dispatch(OpenPopup('staffLogin'));
    }
});

export default connect()(StaffLoginPopup);